import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * POST `/crm/customer-order/{id}/terminate`。
 * body：`terminateReason`、`updatedAt`（record）。
 */
export async function terminateCustomerOrder(id, payload) {
  const { data: raw } = await request.post(
    `/crm/customer-order/${id}/terminate`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
